import React, { Fragment } from 'react';
import CategoryToolTile from './CategoryToolTile';
import PropTypes from 'prop-types';
import { BodyText } from '@paypalcorp/pp-react';

import { AMPLITUDE } from '../../../lib/constants';

const { CATEGORY_APP_TILE_CLICK } = AMPLITUDE;

class Section extends React.Component {
  componentDidMount() {
    const { fptiImpression, content: { sectionFPTI = '' } = {} } = this.props;
    fptiImpression({ pageLink: sectionFPTI, category: 'parent' });
  }

  render() {
    const {
      content: { sectionTitle, sectionBody, sectionFPTI } = {},
      tools,
      path,
      fptiClick,
      fptiImpression,
      toolTileProps,
      isNewLayoutEligible
    } = this.props;

    const handleClickTool = ({
      fptiLink,
      prod,
      PSUrl,
      categoryRank,
      sectionRank,
      appKey,
      rank,
      priorityScore
    }) => {
      return () => {
        fptiClick({
          fptiLink,
          prod,
          pageLink: sectionFPTI,
          categoryRank,
          sectionRank,
          appKey,
          rank,
          priorityScore,
          amplitude: true,
          event_name: CATEGORY_APP_TILE_CLICK
        });
        fetch(PSUrl);
      };
    };

    const getCategoryLayout = () => {
      if (isNewLayoutEligible) {
        return tools.length < 4 ? ' section-grid singleton' : 'section-grid';
      }
      return 'section-tools';
    };

    return (
      <Fragment>
        <h3>{sectionTitle}</h3>
        <BodyText >{sectionBody}</BodyText>
        <div className={getCategoryLayout()}>
          {tools.map((t, index) => (
            <CategoryToolTile
              key={`section-tool-${index}`}
              handleClickTool={handleClickTool}
              tool={t}
              path={path}
              toolTileProps={toolTileProps}
              fptiImpression={fptiImpression}
              fpti={sectionFPTI}
              insideSection={true}
            />
          ))}
        </div>
      </Fragment>
    );
  }
}

Section.propTypes = {
  content: PropTypes.object,
  tools: PropTypes.array,
  path: PropTypes.string,
  fptiImpression: PropTypes.func,
  fptiClick: PropTypes.func,
  toolTileProps: PropTypes.object,
  isNewLayoutEligible: PropTypes.bool
};

export default Section;
